export const TABLES = [
    'bell_schedule',
    'buildings',
    'calendar_schedule',
    'classes',
    'classes_types',
    'current_streams',
    'curriculum',
    'cyclical_commissions',
    'days',
    'directions',
    'funding_types',
    'groups',
    'industrial_practice',
    'practice_schedule',
    'rooms',
    'subjects',
    'teachers',
    'workloads',
]

export const TABLE_FIELDS = {
    days: {
        name: 'text',
        numerator: 'checkbox',
    },
    teachers: {
        lastname: 'text',
        firstname: 'text',
        patronymic: 'text',
        status: 'text',
        rank: 'text',
        academic_degree: 'text',
        external_id: 'text',
    },
    subjects: {
        name: 'text',
        cycle_committee_id: 'number',
        class_type_id: 'number',
        abbreviation: 'text',
    },
    rooms: {
        name: 'text',
        purpose: 'text',
        building_id: 'number',
        responsible_id: 'number',
    },
    classes_types: {
        name: 'text',
    },
    bell_schedule: {
        start_time: 'time',
        end_time: 'time',
        slot_index: 'number',
    },
    buildings: {
        address: 'text',
    },
    calendar_schedule: {
        start_date: 'date',
        end_date: 'date',
        session_start_date: 'date',
        session_end_date: 'date',
        semester: 'number',
    },
    current_streams: {
        schedule_id: 'number',
        group_id: 'number',
    },
    curriculum: {
        workload_id: 'number',
        group_id: 'number',
    },
    cyclical_commissions: {
        name: 'text',
        supervisor_id: 'number',
        abbreviation: 'text',
    },
    directions: {
        course: 'text',
        name: 'text',
    },
    funding_types: {
        name: 'text',
    },
    industrial_practice: {
        practice_id: 'text',
        direction_id: 'number',
        practice_module: 'text',
    },
    practice_schedule: {
        group_id: 'number',
        start_date: 'date',
        end_date: 'date',
    },
    workloads: {
        schedule_id: 'number',
        subject_id: 'number',
        teacher_id: 'number',
        hours_count: 'number',
        weeks_count: 'number',
    },
}

export const FIELD_REFERENCES = {
    cycle_committee_id: 'cyclical_commissions',
    class_type_id: 'classes_types',
    building_id: 'buildings',
    responsible_id: 'teachers',
    schedule_id: 'calendar_schedule',
    group_id: 'groups',
    workload_id: 'workloads',
    supervisor_id: 'teachers',
    direction_id: 'directions',
    subject_id: 'subjects',
    teacher_id: 'teachers',
}

export const DEFAULT_TABLE = 'days'
